import ReCAPTCHA from "react-google-recaptcha";

import { useState, useEffect } from "react";

// 1. Accept Props
function VisaForm({ countryName = "", visaId = "" }) {
      const [token, setToken] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact_number: "",
    adult: 1,
    child: 0,
    infant: 0,
    nationality: "",
    hear_about_us: "Business", // Default changed to match options
    message: "",
    country_name: "", // Will be set by props
    visa_id: "",       // Will be set by props
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({
    type: "",
    message: "",
  });

  // 2. Sync Props to State (Hidden Fields)
  useEffect(() => {
    if (countryName) {
      setFormData((prev) => ({
        ...prev,
        country_name: countryName,
        visa_id: visaId,
      }));
    }
  }, [countryName, visaId]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Limit adult / child / infant values
    if (["adult", "child", "infant"].includes(name)) {
      const num = Number(value);
      if (num < 0 || num > 5) return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.name || !formData.email || !formData.contact_number || !formData.nationality) {
      setStatus({
        type: "error",
        message: "Please fill all required fields.",
      });
      return;
    }

    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await fetch(
        "https://planjourneysglobal.com/admin/api/visa_form",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

 if (!token) {
          alert("Please verify captcha");
          return;
        }

    console.log("Token:", token);
      const result = await response.json();
      if (response.ok) {
        setStatus({
          type: "success",
          message: "Form submitted successfully!",
        });

        // Reset form (Keep country_name and visa_id from previous state)
        setFormData((prev) => ({
          ...prev,
          name: "",
          email: "",
          contact_number: "",
          adult: 1,
          child: 0,
          infant: 0,
          nationality: "",
          hear_about_us: "Business",
          message: "",
        }));
      } else {
        setStatus({
          type: "error",
          message: result?.message || "Something went wrong.",
        });
      }
    } catch (error) {
      setStatus({
        type: "error",
        message: "Server error. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* 3. Hidden Fields sent to API */}
      <input  type="hidden" name="country_name" value={formData.country_name} />
      <input type="hidden" name="visa_id" value={formData.visa_id} />

      {/* Name */}
      <div className="mb-3">
        <label className="form-label">
          Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          name="name"
          className="form-control"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>

      {/* Email */}
      <div className="mb-3">
        <label className="form-label">
          Email <span className="text-danger">*</span>
        </label>
        <input
          type="email"
          name="email"
          className="form-control"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      {/* Contact Number */}
      <div className="mb-3">
        <label className="form-label">
          Contact Number <span className="text-danger">*</span>
        </label>
        <input
          type="tel"
          name="contact_number"
          className="form-control"
          value={formData.contact_number}
          onChange={handleChange}
          maxLength="10"
          required
        />
      </div>

      {/* Adult / Child / Infant */}
      <div className="row mb-3">
        <div className="col">
          <label className="form-label">Adult</label>
          <select
            name="adult"
            className="form-select"
            value={formData.adult}
            onChange={handleChange}
          >
            {[1, 2, 3, 4, 5].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>

        <div className="col">
          <label className="form-label">Child</label>
          <select
            name="child"
            className="form-select"
            value={formData.child}
            onChange={handleChange}
          >
            {[0, 1, 2, 3, 4, 5].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>

        <div className="col d-none">
          <label className="form-label">Infant</label>
          <select
            name="infant"
            className="form-select"
            value={formData.infant}
            onChange={handleChange}
          >
            {[0, 1, 2].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Nationality */}
      <div className="mb-3">
        <label className="form-label">
          Nationality <span className="text-danger">*</span>
        </label>
        <select
          name="nationality"
          className="form-select"
          value={formData.nationality}
          onChange={handleChange}
          required
        >
         <option value="Afghanistan">Afghanistan</option>
<option value="Albania">Albania</option>
<option value="Algeria">Algeria</option>
<option value="Argentina">Argentina</option>
<option value="Australia">Australia</option>
<option value="Austria">Austria</option>
<option value="Bangladesh">Bangladesh</option>
<option value="Belgium">Belgium</option>
<option value="Brazil">Brazil</option>
<option value="Bulgaria">Bulgaria</option>
<option value="Canada">Canada</option>
<option value="Chile">Chile</option>
<option value="China">China</option>
<option value="Colombia">Colombia</option>
<option value="Croatia">Croatia</option>
<option value="Czech Republic">Czech Republic</option>
<option value="Denmark">Denmark</option>
<option value="Egypt">Egypt</option>
<option value="Finland">Finland</option>
<option value="France">France</option>
<option value="Germany">Germany</option>
<option value="Greece">Greece</option>
<option value="Hong Kong">Hong Kong</option>
<option value="Hungary">Hungary</option>
<option value="Iceland">Iceland</option>
<option value="India">India</option>
<option value="Indonesia">Indonesia</option>
<option value="Iran">Iran</option>
<option value="Iraq">Iraq</option>
<option value="Ireland">Ireland</option>
<option value="Israel">Israel</option>
<option value="Italy">Italy</option>
<option value="Japan">Japan</option>
<option value="Jordan">Jordan</option>
<option value="Kenya">Kenya</option>
<option value="Kuwait">Kuwait</option>
<option value="Malaysia">Malaysia</option>
<option value="Mexico">Mexico</option>
<option value="Morocco">Morocco</option>
<option value="Nepal">Nepal</option>
<option value="Netherlands">Netherlands</option>
<option value="New Zealand">New Zealand</option>
<option value="Nigeria">Nigeria</option>
<option value="Norway">Norway</option>
<option value="Oman">Oman</option>
<option value="Pakistan">Pakistan</option>
<option value="Philippines">Philippines</option>
<option value="Poland">Poland</option>
<option value="Portugal">Portugal</option>
<option value="Qatar">Qatar</option>
<option value="Romania">Romania</option>
<option value="Russia">Russia</option>
<option value="Saudi Arabia">Saudi Arabia</option>
<option value="Singapore">Singapore</option>
<option value="South Africa">South Africa</option>
<option value="South Korea">South Korea</option>
<option value="Spain">Spain</option>
<option value="Sri Lanka">Sri Lanka</option>
<option value="Sweden">Sweden</option>
<option value="Switzerland">Switzerland</option>
<option value="Thailand">Thailand</option>
<option value="Turkey">Turkey</option>
<option value="UAE">United Arab Emirates</option>
<option value="UK">United Kingdom</option>
<option value="USA">United States</option>
<option value="Ukraine">Ukraine</option>
<option value="Vietnam">Vietnam</option>
<option value="Zimbabwe">Zimbabwe</option>
</select>
       
      </div>

      {/* Purpose Of Visit */}
      <div className="mb-3">
        <label className="form-label">Purpose Of Visit</label>
        <select
          name="hear_about_us"
          className="form-select"
          value={formData.hear_about_us}
          onChange={handleChange}
        >
          <option value="Business">Business</option>
          <option value="Tourist">Tourist</option>
        </select>
      </div>

      {/* Message */}
      <div className="mb-3">
        <label className="form-label">Your message (optional)</label>
        <textarea
          name="message"
          className="form-control"
          rows="3"
          value={formData.message}
          onChange={handleChange}
        />
      </div>
  <div className="mb-3">
        <label className="form-label">Capthca *</label>

      <ReCAPTCHA className="wrpaercp"
              sitekey="6LfXRZ8sAAAAADZ4XO4fQECm-adXRbal1rJxaPcv"
              onChange={(value) => setToken(value)}
            />
</div>
      {/* Submit Button */}
      <button type="submit" className="primary-btn1" disabled={loading}>
        <span>{loading ? "Submitting..." : "Get a Quote"}</span>
        <span>{loading ? "Submitting..." : "Get a Quote"}</span>
      </button>

      {/* Status Message BELOW button */}
      {status.message && (
        <div
          className={`mt-3 alert ${
            status.type === "success" ? "alert-success" : "alert-danger"
          }`}
          role="alert"
        >
          {status.message}
        </div>
      )}
    </form>
  );
}

export default VisaForm;